import { createSelector } from 'reselect'

/**
 * Select only active buildings
 */
export const getBuildings = createSelector(
  state => state.workspace.buildings,
  (buildings) => buildings.filter((building) => (!building.archive))
)


/**
 * Select only floors for the active building
 */
export const floorsByBuilding = createSelector(
  state => state._workspace.selected.building,
  state => state.workspace.floors,
  (building, floors) => floors.filter((floor) => (floor.building === building && !floor.archive))
)

/**
 * Select only areas applicable for the building and floor
 */
export const areasByBuildingFloor = createSelector(
  state => state._workspace.selected.building,
  state => state._workspace.selected.floor,
  state => state.workspace.areas,
  (building, floor, areas) => {
    return areas.filter((area) => (area.building === building && (!floor || (area.floor === floor)) && !area.archive))
  }
)